<div class="dashboard-container">
    <button type="button" class="mobile-filter-backdrop" *ngIf="isMobileView && isMobileMenuOpen"
        (click)="closeMobileMenu()" aria-label="Đóng menu"></button>

    <nav class="side-nav" [class.mobile-open]="isMobileMenuOpen">

        <div class="side-section">

            <button type="button" class="side-link-btn" [class.is-active]="isMainStockActive()"
                routerLink="/dashboard/stocks" (click)="onHomeClick(); closeMobileMenu()">

                <span class="side-icon">
                    <svg viewBox="0 0 24 24">
                        <path d="M3 10l9-7 9 7v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" />
                    </svg>
                </span>

                 Trang chủ
            </button>

            <!-- Filters: show only on main stocks page, positioned between menu items -->
            <div *ngIf="isMainStockActive()">

                <div class="side-section-title">Khoảng giá</div>
                <div class="price-filter-box">
                    <button type="button" class="price-option" *ngFor="let option of priceFilterOptions"
                        (click)="selectPriceRange(option.value)" [class.active]="priceFilterValue === option.value"
                        [attr.aria-pressed]="priceFilterValue === option.value" [disabled]="isMyStockActive()">
                        <span class="price-checkbox" aria-hidden="true"></span>
                        <span class="price-option-label">{{ option.label }}</span>
                    </button>
                </div>
                <div class="side-section-title">Lợi nhuận dự kiến</div>
                <div class="price-filter-box">
                    <button type="button" class="price-option" *ngFor="let option of filterSort"
                        (click)="sort(option.value)" [class.active]="sortOrder === option.value"
                        [attr.aria-pressed]="sortOrder === option.value" [disabled]="isMyStockActive()">
                        <span class="price-checkbox" aria-hidden="true"></span>
                        <span class="price-option-label">{{ option.label }}</span>
                    </button>
                </div>
            </div>

            <div class="side-section" *ngIf="canViewRequestList">
                <button type="button" class="side-link-btn" routerLink="/dashboard/user-stocks"
                    routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">
                    <span class="side-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M3 3h8v8H3zM13 3h8v5h-8zM13 10h8v11h-8zM3 13h8v8H3z" />
                        </svg>
                    </span>
                     Quản lý kho người dùng
                </button>
            </div>

            <div class="side-section" *ngIf="canViewRequestList">
                <button type="button" class="side-link-btn" routerLink="/dashboard/users" routerLinkActive="is-active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="side-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M16 14c2.7 0 6 1.3 6 4v2H2v-2c0-2.7 3.3-4 6-4m8-6a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" />
                        </svg>
                    </span>
                     Quản lý người dùng
                </button>
            </div>

            <div class="side-section" *ngIf="canViewMyStock">
                <button type="button" class="side-link-btn" routerLink="/dashboard/user-stocks"
                    [queryParams]="{ scope: 'my' }">

                    <span class="side-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M3 3h18v4H3zM3 9h18v12H3z" />
                        </svg>
                    </span>

                     Kho của tôi
                </button>
            </div>

            <div class="side-section" *ngIf="canViewRequestList">
                <button type="button" class="side-link-btn" routerLink="/dashboard/requests"
                    routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">
                    <span class="side-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M4 4h16v2H4zM4 10h16v2H4zM4 16h10v2H4z" />
                        </svg>
                    </span>
                     Danh sách yêu cầu
                </button>
            </div>
            <div class="side-section" *ngIf="canViewRequestList">
                <button type="button" class="side-link-btn" routerLink="/dashboard/benefit" routerLinkActive="is-active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span class="side-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z" />
                        </svg>
                    </span>
                     Chương trình hậu đãi
                </button>
            </div>

            <div class="side-section" *ngIf="canViewRequestList">
                <button type="button" class="side-link-btn" routerLink="/dashboard/chat-admin"
                    routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">
                    <span class="side-icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M4 4h16v12H5.17L4 17.17V4z" />
                        </svg>
                    </span>
                     Chat (Admin)
                </button>
            </div>
            <button type="button" class="side-link-btn" routerLink="/dashboard/policy" routerLinkActive="is-active"
                [routerLinkActiveOptions]="{ exact: true }">
                <span class="side-icon">
                    <svg viewBox="0 0 24 24">
                        <path d="M6 2h9l5 5v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM14 2v6h6" />
                    </svg>
                </span>
                 Chính sách điều khoản
            </button>
            <button type="button" class="side-link-btn" routerLink="/dashboard/contact" routerLinkActive="is-active"
                [routerLinkActiveOptions]="{ exact: true }">
                <span class="side-icon">
                    <svg viewBox="0 0 24 24">
                        <path d="M21 8V7l-3 2-2-1-2 1-2-1-2 1-2-1-3 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    </svg>
                </span>
                 Liên hệ
            </button>
            <div>
                <p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p>
            </div>
        </div>
    </nav>
</div>

<!-- dashboard.component.html -->
<main class="main-content">
    <router-outlet #childOutlet="outlet"></router-outlet>

    <app-footer *ngIf="showFooter"></app-footer>
</main>

<!-- User chat bubble (only for non-admin) -->
<app-chat-bubble *ngIf="!canViewRequestList && this.loginService.isLoggedIn() "></app-chat-bubble>

<app-modal-upload #uploadModal (fileUploaded)="onUploaded($event)">
</app-modal-upload>